import {createReducer} from '@reduxjs/toolkit';
import {SetPayments, SetPaymentsPagination} from './ActionTypes/Payment';

interface PaymentState {
  payments: any[];
  paymentsPagination: {count: number; pages: number};
}

const initialState: PaymentState = {
  payments: [],
  paymentsPagination: {count: 0, pages: 0},
};

const paymentReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(SetPayments, (state, action) => {
      state.payments = action.payload;
    })
    .addCase(SetPaymentsPagination, (state, action) => {
      state.paymentsPagination = action.payload;
    });
});

export default paymentReducer;
